import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

/* Pulls its child toward the cursor while hovering (premium button feel) */
export default function Magnetic({ children, strength = 0.35, className, style }) {
  const ref = useRef(null);
  const x = useSpring(useMotionValue(0), { stiffness: 200, damping: 15, mass: 0.4 });
  const y = useSpring(useMotionValue(0), { stiffness: 200, damping: 15, mass: 0.4 });
  const onMove = (e) => {
    if (e.pointerType === 'touch') return;
    const r = ref.current.getBoundingClientRect();
    x.set((e.clientX - (r.left + r.width / 2)) * strength);
    y.set((e.clientY - (r.top + r.height / 2)) * strength);
  };
  const reset = () => { x.set(0); y.set(0); };
  return (
    <motion.div ref={ref} className={`magnetic ${className || ''}`} style={{ x, y, display: 'inline-flex', ...style }} onPointerMove={onMove} onPointerLeave={reset}>
      {children}
    </motion.div>
  );
}
